import { SidebarProvider } from "@repo/ui/components/ui/sidebar";
import type { ReactNode } from "react";

const keepOpen = () => {};

/**
 * Always expanded on desktop: the portal has no desktop toggle, so a stored
 * "collapsed" state (the fallback cookie is shared by every app on a host)
 * would leave a patient with no way back. The phone menu keeps its own state.
 */
export function PortalSidebarProvider({ children }: { children: ReactNode }) {
  return (
    <SidebarProvider open onOpenChange={keepOpen} enableKeyboardShortcut={false}>
      {children}
    </SidebarProvider>
  );
}
